import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const SidebarItem = ({ item, activeMenu, setActiveMenu }) => {
  const location = useLocation();
  const hasSubmenu = item.submenu ? true:false;

  // ✅ Check if any submenu item should be active
  const isActive = item.submenu?.some(
    (sub) =>
      location.pathname.startsWith(sub.url) || // ✅ Check if the current path starts with submenu URL
      (sub.activemenu && sub.activemenu.some((path) => location.pathname.startsWith(path))) // ✅ Support activemenu array
  );

  // Auto-open submenu only if no menu is currently active
  useEffect(() => {
    if (isActive && !activeMenu) {
      setActiveMenu(item.name);
    }
  }, [isActive, item.name, activeMenu, setActiveMenu]);

  const toggleMenu = () => {
    setActiveMenu(activeMenu === item.name ? null : item.name);
  };
// console.log(hasSubmenu);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        {hasSubmenu ? (
          <button
            className={`accordion-button ${activeMenu === item.name ? "" : "collapsed"}`}
            onClick={toggleMenu}
            aria-expanded={activeMenu === item.name}
          >
            <span><i className={item.icon}></i></span> {item.name}
          </button>
        ) : (
          <NavLink className="accordion-button arrow_none collapsed" to={item.url}>
            <span><i className={item.icon}></i></span> {item.name}
          </NavLink>
        )}
      </h2>

      {/* Render Submenu */}
      {hasSubmenu && (
        <div className={`accordion-collapse collapse ${activeMenu === item.name ? "show" : ""}`}>
          <ul>
            {item.submenu.map((sub, index) => {
              const isSubActive =
                location.pathname.startsWith(sub.url) || // ✅ Check if current path starts with submenu URL
                (sub.activemenu && sub.activemenu.some((path) => location.pathname.startsWith(path)));

              return (
                <li key={index}>
                  <NavLink className={`inner_link ${isSubActive ? "active" : ""}`} to={sub.url}>
                    <span><i className={sub.icon}></i></span> {sub.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SidebarItem;

